function record(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

export function articleApiErrorMessage(payload: unknown, fallback: string) {
  const body = record(payload);
  if (!body) return fallback;

  const details = Object.entries(record(body.errors) ?? {}).flatMap(
    ([field, value]) => {
      const messages = (Array.isArray(value) ? value : [value]).filter(
        (message): message is string =>
          typeof message === 'string' && message.trim().length > 0
      );
      const label = field.replace(/_/g, ' ');
      return messages.map((message) =>
        field === 'general' ? message.trim() : `${label}: ${message.trim()}`
      );
    }
  );
  if (details.length) return [...new Set(details)].join('\n');
  return typeof body.message === 'string' && body.message.trim()
    ? body.message.trim()
    : fallback;
}

export function articleErrorMessage(error: unknown, fallback: string) {
  const response = record(record(error)?.response);
  if (response) return articleApiErrorMessage(response.data, fallback);
  return error instanceof Error && error.message.trim()
    ? error.message
    : fallback;
}
